import { ClosedEyeIcon, OpenEyeIcon } from "assets/icons";
import { useMemo, useState } from "react";
import styles from "./PrivateKeyField.module.css";

const PrivateKeyField = ({
  value = "",
  onChange,
  name = "private_key",
  placeholder = "Private key",
  show = false,
  label = false,
  readOnly = false,
  disabled = false,
  className = "",
  autoFocus = false,
  style,
  wrapperStyle,
  inputClassName = "",
  labelClassName = "",
  toggleClassName = "",
  onBlur,
}) => {
  const [isVisible, setIsVisible] = useState(show);

  const maskedValue = useMemo(() => {
    if (!value) return "";
    return "•".repeat(Math.min(String(value).length, 32));
  }, [value]);

  return (
    <div className={`${styles.wrapper} ${className}`} style={wrapperStyle}>
      {label ? (
        <p className={`${styles.labelValue} ${labelClassName}`} style={style}>
          {isVisible ? value : maskedValue}
        </p>
      ) : (
        <input
          autoFocus={autoFocus}
          type={isVisible ? "text" : "password"}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          className={`${styles.input} ${inputClassName}`}
          style={style}
        />
      )}
      <button
        type="button"
        className={`${styles.toggle} ${toggleClassName}`}
        onClick={() => setIsVisible((prev) => !prev)}
        aria-label={isVisible ? "Hide private key" : "Show private key"}
        title={isVisible ? "Hide private key" : "Show private key"}
      >
        {isVisible ? <OpenEyeIcon /> : <ClosedEyeIcon />}
      </button>
    </div>
  );
};

export default PrivateKeyField;
